import { render, staticRenderFns } from "./ServiceTypeForm.vue?vue&type=template&id=1461d34b&"
import script from "./ServiceTypeForm.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports